import { render, staticRenderFns } from "./cardPaganation.vue?vue&type=template&id=77b4c161&scoped=true"
import script from "./cardPaganation.vue?vue&type=script&lang=js"
export * from "./cardPaganation.vue?vue&type=script&lang=js"
import style0 from "./cardPaganation.vue?vue&type=style&index=0&id=77b4c161&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b4c161",
  null
  
)

export default component.exports